import React from 'react'
import './AddEditUserForm.scss'
import { Box, Button, FormControl, FormControlLabel, FormGroup, FormLabel, IconButton, InputAdornment, InputLabel, OutlinedInput, Switch, TextField } from '@mui/material'

import { useFormik } from 'formik'
import * as Yup from 'yup';
import { useUser } from '../../../../hook';


export function AddEditUserForm(props) {

    const {onClose, onRefreshUser, user} = props;

    const {addUser, editUser} = useUser();

    const formik = useFormik({
        //PASO 1: INITIAL VALUES
        initialValues: !user ? initialValues() : initialValuesEdit(user),
        //PASO 2: VALIDATION SCHEMA
        validationSchema: Yup.object( !user ? newValidationSchema() : newValidationSchemaEdit()),
        //PASO 3: Validation ONCHANGE
        validateOnChange: false,
        //PASO 4: ONSUBMIT ARROW Function
        onSubmit: async(formValue) =>{
            try {
                if(user) editUser(user.id, formValue)
                else await addUser(formValue);
                onRefreshUser();
                onClose();

            } catch (error) {
                console.error(error)
            }
        }
    })

  return (
    <>
        {/*/<TextField id="filled-basic" label="Filled" variant="filled" />
            <TextField id="standard-basic" label="Standard" variant="standard" />/*/}
         <Box 
            component="form"
            sx={{
                '& > :not(style)': { m: 1, width: '100%' },
            }}
            noValidate
            autoComplete="off"
            onSubmit={formik.handleSubmit}
            >

            <TextField 
            name="username" label="Username" variant="outlined"
            value={formik.values.username}
            onChange={formik.handleChange}
            error={formik.errors.username} 
            />

            <TextField 
            name="email" label="Email" variant="outlined"
            value={formik.values.email}
            onChange={formik.handleChange}
            error={formik.errors.email}  
            />

            <TextField 
            name="first_name" label="Firts name" variant="outlined" 
            value={formik.values.first_name}
            onChange={formik.handleChange}
            error={formik.errors.first_name} 
            />

            <TextField 
            name="last_name" label="Last name" variant="outlined" 
            value={formik.values.last_name}
            onChange={formik.handleChange}
            error={formik.errors.last_name}  
            />

            <TextField 
            name="password" label="Password" variant="outlined" 
            value={formik.values.password}
            onChange={formik.handleChange}
            error={formik.errors.password}  
            />

            <FormControl component="fieldset" variant="standard">
                <FormLabel component="legend">Permisos Especiales</FormLabel>
                
                <FormGroup>
                    
                    <FormControlLabel
                    control={
                        <Switch 
                        defaultChecked={formik.values.is_active} 
                        onChange={(_, data)=> formik.setFieldValue("is_active", data)}
                        />
                    }
                    label="Usuario Activo"
                    />

                    <FormControlLabel
                    control={
                        <Switch 
                        defaultChecked={formik.values.is_staff}
                        onChange={(_, data)=> formik.setFieldValue("is_staff", data)}
                        />
                    }
                    label="Es Administrador"
                    />
                    
                </FormGroup> 

                </FormControl>

                <Button type="submit" variant="contained">
                   {!user ? 'Enviar' : 'Editar'} 
                </Button>
         
         </Box >
    </>
  )
}


function initialValues(){
    return{
    username: "",
    email: "",
    first_name: "",
    last_name: "",
    is_active: true,
    is_staff: false,
    password: ""
    }
}

function initialValuesEdit(user){
    const {username,  email, first_name, last_name, is_active, is_staff, password} = user;
    //console.log(is_active);
    return{
    username,
    email,
    first_name,
    last_name,
    is_active,
    is_staff,
    password: ""
    }
}

function newValidationSchema(){
    return{
        username: Yup.string().required(true),
        email: Yup.string().email(true).required(true),
        first_name: Yup.string(),
        last_name: Yup.string(),
        is_active: Yup.bool().required(true),
        is_staff: Yup.bool().required(true),
        password: Yup.string().required(true), 
    }
}

function newValidationSchemaEdit(){
    return{
        username: Yup.string().required(true),
        email: Yup.string().email(true).required(true),
        first_name: Yup.string(),
        last_name: Yup.string(),
        is_active: Yup.bool().required(true),
        is_staff: Yup.bool().required(true),
        password: Yup.string(), 
    }
}